module.exports = __webpack_public_path__ + "img/banner_1.dc6e672f.jpg";